import { render, staticRenderFns } from "./FeesType.vue?vue&type=template&id=2fde00c7&scoped=true"
import script from "./FeesType.vue?vue&type=script&lang=js"
export * from "./FeesType.vue?vue&type=script&lang=js"
import style0 from "./FeesType.vue?vue&type=style&index=0&id=2fde00c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde00c7",
  null
  
)

export default component.exports